import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DeviceInfoExportResponse,
  DeviceInfoResponse,
  DeviceResponse,
} from '@entities/deviceInfo';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceInfoService {
  constructor(private api: ApiService) {}

  /**
   * 最新のデバイス情報を取得する
   * @returns デバイス情報
   */
  findByIdLatest(
    serialNo: string,
    searchFrom?: string,
    searchTo?: string,
  ): Observable<DeviceInfoResponse> {
    // クエリストリングを追加
    let params = new HttpParams();
    if (searchFrom) params = params.set('search_from', searchFrom);
    if (searchTo) params = params.set('search_to', searchTo);

    const url = `/device-info/${serialNo}/latest`;
    return this.api.get<DeviceInfoResponse>(url, { params });
  }

  /**
   * 指定した日付範囲に含まれるデバイス情報履歴を取得する
   * @returns デバイス情報履歴
   */
  findByIdHistoryLatest(
    serialNo: string,
    historyFrom: string,
    historyTo: string,
  ): Observable<DeviceInfoResponse> {
    // クエリストリングを追加
    let params = new HttpParams();
    params = params.set('history_from', historyFrom);
    params = params.set('history_to', historyTo);

    const url = `/device-info/${serialNo}/history/latest`;
    return this.api.get<DeviceInfoResponse>(url, { params });
  }

  /**
   * 指定した日付範囲に含まれるエクスポート用のデバイス情報履歴を取得する
   * @returns デバイス情報履歴
   */
  findByIdExportHistory(
    serialNo: string,
    historyFrom: string,
    historyTo: string,
  ): Observable<DeviceInfoExportResponse[]> {
    // クエリストリングを追加
    let params = new HttpParams();
    params = params.set('history_from', historyFrom);
    params = params.set('history_to', historyTo);

    const url = `/device-info/${serialNo}/export`;
    return this.api.get<DeviceInfoExportResponse[]>(url, { params });
  }

  /**
   * デバイスの位置情報を取得する
   *
   * @param serialNo シリアル番号
   * @param historyFrom 検索期間の開始日時
   * @param historyTo 検索期間の終了日時
   * @returns 位置情報
   */
  findByIdHistory(
    serialNo: string,
    historyFrom: string,
    historyTo: string,
  ): Observable<DeviceInfoResponse[]> {
    // クエリストリングを追加
    let params = new HttpParams();
    params = params.set('history_from', historyFrom);
    params = params.set('history_to', historyTo);

    const url = `/device-info/${serialNo}/history`;
    return this.api.get<DeviceInfoResponse[]>(url, { params });
  }

  /* ユーザーが閲覧できるデバイス一覧情報を取得する
   * @returns デバイス一覧情報
   */
  findDeviceList(): Observable<DeviceResponse[]> {
    const url = `/device-info`;
    return this.api.get<DeviceResponse[]>(url);
  }
}
